// Polyfill console for IE9
window.console =
  window.console ||
  (function () {
    var c = {};
    // prettier-ignore
    c.log = c.warn = c.debug = c.info = c.error = c.time = c.dir = c.profile = c.clear = c.exception = c.trace = c.assert = function() {};
    return c;
  })();

// Polyfill btoa/atob for IE9
import { btoa, atob } from "Base64";
if (!window.btoa) {
  window.btoa = btoa;
}
if (!window.atob) {
  window.atob = atob;
}

// General polyfill - only if not already loaded
if (!window._babelPolyfill) {
  require("babel-polyfill");
}
require("babel-runtime/core-js/promise").default = require("bluebird");
require("whatwg-fetch");

// Polyfill currentScript
import currentExecutingScript from "current-executing-script";

// Load React
import React from "react";
import ReactDOM from "react-dom";

// CSS
import "../app/icon.css";
import "./widget.scss";

// Logging setup
import "../app/logger";

// Fix popover bugs
import "../app/popover-fix.js";

let script = document.currentScript || currentExecutingScript(),
  baseDomain = script.src.replace(/\/loader\.js.*$/, "");

fetch(baseDomain + "/config.json")
  .then(resp => resp.json())
  .then(config => {
    window.EVENTIVE_CONFIG = window.TENANT = config;
    window.EVENTIVE_IS_EVERYWHERE = true;
    render();
  });

// Create shell, which will queue up requests until the integration is fully loaded.
// Also offers an on ready handler.
let pendingApiRequests = [];
let pendingReadyHandlers = [];
let universalTicketBucketActionHandlers = [];
let editPaymentMethodActionHandlers = [];
let apiWrapperReady = false;
function apiWrapperOnHandler(state, fn) {
  if (state === "ready") {
    if (apiWrapperReady) {
      fn();
    } else {
      pendingReadyHandlers.push(fn);
    }
  } else if (state === "universal_ticket_button_action") {
    universalTicketBucketActionHandlers.push(fn);
    // The consumer of this API will implement like this:
    //
    // window.Eventive.on('universal_ticket_button_action', (event) => {
    //  console.log('target event', event.target.event_id);
    //  console.log('action', event.action); // 'play', 'order_placed', 'ticket_canceled', 'custom_action'
    //                                       // (Note: 'play' only fires if data-consume-play-action=true)
    //  console.log('custom action', event.custom_action_name); // 'user_generated'
    // });
    //
    // For custom actions, those can be added by
    // <div class="eventive-button"
    //    data-universal
    //    data-consume-play-action="true"
    //    data-custom-actions="[{\"name\":\"user_generated\",\"label\":\"User Generated\"}]"
    //  ></div>
  } else if (state === "edit_payment_method_button_action") {
    editPaymentMethodActionHandlers.push(fn);
  } else {
    throw new Error(`Unknown state passed to Eventive.on: "${state}"`);
  }
}
function apiWrapperOffHandler(state, fn) {
  if (state === "ready") {
    if (fn) {
      pendingReadyHandlers = pendingReadyHandlers.filter(f => f !== fn);
    } else {
      pendingReadyHandlers = [];
    }
  } else if (state === "universal_ticket_button_action") {
    if (fn) {
      universalTicketBucketActionHandlers =
        universalTicketBucketActionHandlers.filter(f => f !== fn);
    } else {
      universalTicketBucketActionHandlers = [];
    }
  } else if (state === "edit_payment_method_button_action") {
    if (fn) {
      editPaymentMethodActionHandlers =
        editPaymentMethodActionHandlers.filter(f => f !== fn);
    } else {
      editPaymentMethodActionHandlers = [];
    }
  } else {
    throw new Error(`Unknown state passed to Eventive.off: "${state}"`);
  }
}

window.Eventive = {
  request: opts => {
    return new Promise((resolve, reject) => {
      pendingRequests.push({ opts, resolve, reject });
    });
  },
  isLoggedIn: () => false,
  getPersonDetails: () => {},
  on: apiWrapperOnHandler,
  off: apiWrapperOffHandler
};

function render() {
  const api = require("../app/utils/api");
  const AppActions = require("../app/actions/AppActions");
  const AppStore = require("../app/stores/AppStore");
  const PersonActions = require("../app/actions/PersonActions");
  const PersonStore = require("../app/stores/PersonStore");
  const EventActions = require("../app/actions/EventActions");
  const PassActions = require("../app/actions/PassActions");
  const WishlistStore = require("../app/stores/WishlistStore");
  const WishlistActions = require("../app/actions/WishlistActions");
  const OrderStore = require("../app/stores/OrderStore");
  const OrderActions = require("../app/actions/OrderActions");
  const EventStore = require("../app/stores/EventStore");
  const PassStore = require("../app/stores/PassStore");
  const WidgetContainer = require("./widget-container.jsx");
  const TicketButton = require("../app/components/partials/ticket-button.jsx");
  const UniversalTicketButton = require("../app/components/partials/universal-ticket-button.jsx");
  const VirtualExpressTicketButton = require("../app/components/partials/virtual-express-ticket-button.jsx");
  const PassButton = require("../app/components/partials/pass-button.jsx");
  const ScanPassButton = require("../app/components/partials/scan-pass-button.jsx");
  const EditPaymentMethodButton = require("../app/components/partials/edit-payment-method-button.jsx");
  const VoteButton = require("../app/components/partials/vote-button.jsx");
  const ViewCartButton = require("../app/components/partials/view-cart-button.jsx");
  const ResetCartButton = require("../app/components/partials/reset-cart-button.jsx");
  const AddToCartButton = require("../app/components/partials/add-to-cart-button.jsx");
  const LoginWidget = require("./login-widget.jsx");
  const CustomButton = require("./custom-button.jsx");
  const CheckoutWidget = require("./checkout-widget.jsx");
  const BallotingRecord = require("../app/components/partials/balloting-record.jsx");

  // Handler for login errors -- force logout and then let them try again
  window.EVENTIVE_EVERYWHERE_HISTORY = {
    push: location => {
      if (
        location.pathname === "/login" &&
        location.state &&
        location.state.fromApiLoginError
      ) {
        PersonActions.logout();
      }
    }
  };

  // API wrapper more advanced requests
  window.Eventive = {
    request: opts => {
      return new Promise((resolve, reject) => {
        if (opts.authenticatePerson) {
          delete opts.authenticatePerson;
          let token = PersonStore.getState().token;
          if (opts.qs) {
            opts.qs.token = token;
          } else if (opts.json) {
            opts.json.token = token;
          } else {
            opts.qs = { token };
          }
        }

        api.request(opts, (err, resp) => {
          if (err) {
            return reject(err);
          }
          resolve(resp);
        });
      });
    },
    isLoggedIn: PersonStore.isLoggedIn,
    getPersonDetails: PersonStore.getPersonDetails,
    on: apiWrapperOnHandler,
    off: apiWrapperOffHandler,
    rebuild: inject,
    openVote: openVote,
    wishlist: {
      getWishlist: WishlistStore.getWishlist,
      isWishlisted: WishlistStore.isWishlisted,
      getUnticketedWishlistEvents: WishlistStore.getUnticketedWishlistEvents,
      add: WishlistActions.add,
      remove: WishlistActions.remove
    },
    cart: {
      getCurrentCartOrder: getCurrentCartOrder,
      getCartQuantity: OrderStore.getCartQuantity,
      updateCart: updateCart,
      showCart: showCart,
      resetCart: resetCart,
    },
    initiateCheckout: initiateCheckout,
    loginSundance: loginSundance,
    loginWithToken: loginWithToken,
    logout: logout
  };
  apiWrapperReady = true;
  pendingApiRequests.forEach(({ opts, resolve, reject }) => {
    Eventive.request(opts).then(resolve).catch(reject);
  });
  pendingReadyHandlers.forEach(fn => fn());

  let ids = [];
  let hasPassBuckets = false;
  let buttonContainers = [];
  let customButtonContainers = [],
    customButtonContents = [];
  let customLinkElements = [],
    customLinkContents = [],
    customLinkContainers = [];

  function inject() {
    // For some sites (e.g. Wix), links may be getting created/removed all the time. So we have the
    // link-hijack method that aggressively looks at every click.
    let hijackContainerRef = null;
    if (window.EVENTIVE_EVERYWHERE_HIJACK) {
      window.addEventListener("click", e => {
        // Support one layer of nesting within (e.g. <a><span>Click here</span></a>).
        let possibleLinkEl =
          e.target.parentElement && e.target.parentElement.tagName === "A"
            ? e.target.parentElement
            : e.target;

        if (
          hijackContainerRef &&
          possibleLinkEl.matches(
            `a[href*="${baseDomain}"][href$="#everywhere"]`
          )
        ) {
          e.preventDefault();
          e.stopPropagation();

          let match = /\/schedule\/(.+?)(?:\/|\/tickets|#)/.exec(
              possibleLinkEl.href
            ),
            id = match && match[1];

          hijackContainerRef.setTicketsOverlay(id);
        }
      });
    }

    buttonContainers = document.querySelectorAll(".eventive-button");

    customButtonContainers = document.querySelectorAll(
      ".eventive-custom-button"
    );
    customButtonContents = Array.from(customButtonContainers).map(
      c => c.innerHTML
    );

    customLinkElements = document.querySelectorAll(
      `a[href*="${baseDomain}"][href$="#everywhere"]`
    );
    customLinkContents = Array.from(customLinkElements).map(c => c.outerHTML);
    customLinkContainers = Array.from(customLinkElements).map(el => {
      let match = /\/schedule\/(.+?)(?:\/|\/tickets|#)/.exec(el.href),
        id = match && match[1];

      let container = document.createElement("span");
      el.parentNode.insertBefore(container, el);
      container.appendChild(el);

      container.setAttribute("data-event", id);
      return container;
    });

    console.log("List of EE Ids");
    console.log(ids);

    ids = Array.from(buttonContainers)
      .concat(Array.from(customButtonContainers))
      .concat(Array.from(customLinkContainers))
      .map(c => {
        if (c.getAttribute("data-pass-bucket")) {
          hasPassBuckets = true;
        }
        return c.getAttribute("data-event") || c.getAttribute("data-event-id");
      })
      .filter(c => !!c);

    AppActions.fetchSettings();
    // only fetch if there are events to fetch
    if (ids.length > 0) {
      EventActions.fetchAll({ includePastEvents: true, eventIds: ids });
    }

    if (hasPassBuckets) {
      PassActions.fetchPassTypes();
    }

    // load passes for user
    PassActions.fetchAll({ firstTimeOnly: true });
  }

  inject();

  EventStore.listen(_update);
  PassStore.listen(_update);
  AppStore.listen(_update);

  function _update() {
    _render({
      appState: AppStore.getState(),
      eventState: EventStore.getState(),
      passState: PassStore.getState()
    });
  }

  let widgetProps = {
    baseDomain,
    appSettings: null
  };

  function _render({ eventState, appState }) {
    if (appState.fetchSuccessful) {
      widgetProps = {
        baseDomain,
        appSettings: appState.settings
      };
    }

    if (
      appState.fetchSuccessful &&
      ids.every(id => !!eventState.events[id]) &&
      (!hasPassBuckets || PassStore.getState().hasUpdatedAllTypes)
    ) {
      // All events have now been loaded

      // Inject order buttons
      Array.from(buttonContainers).forEach((c, i) => {
        ReactDOM.render(
          <WidgetContainer {...widgetProps}>
            {c.getAttribute("data-event") ? (
              c.hasAttribute("data-universal") ? (
                (() => {
                  // Hack: so that transitions to the /tickets routes work differently.
                  // This is bad and should be refactored.
                  window.__EVENTIVE_EVERYWHERE_HAS_UNIVERSAL = true;

                  const onAction = e => {
                    universalTicketBucketActionHandlers.forEach(fn => {
                      fn(e);
                    });
                  };

                  // Hack: Allow order success to trigger an action.
                  window.__EVENTIVE_EVERYWHERE_UNIVERSAL_ON_ACTION = onAction;

                  return (
                    <UniversalTicketButton
                      event={eventState.events[c.getAttribute("data-event")]}
                      customActions={
                        c.getAttribute("data-custom-actions")
                          ? JSON.parse(c.getAttribute("data-custom-actions"))
                          : null
                      }
                      consumePlayAction={c.hasAttribute(
                        "data-consume-play-action"
                      )}
                      hideScanTickets={c.hasAttribute("data-hide-scan-tickets")}
                      hideActions={c.hasAttribute("data-hide-actions")}
                      onAction={onAction}
                      appSettings={widgetProps.appSettings}
                    />
                  );
                })()
              ) : c.hasAttribute("data-virtual-express") ? (
                (() => {
                  // Hack: so that transitions to the /tickets routes work differently.
                  // This is bad and should be refactored.
                  window.__EVENTIVE_EVERYWHERE_HAS_UNIVERSAL = true;

                  const onAction = e => {
                    universalTicketBucketActionHandlers.forEach(fn => {
                      fn(e);
                    });
                  };

                  // Hack: Allow order success to trigger an action.
                  window.__EVENTIVE_EVERYWHERE_UNIVERSAL_ON_ACTION = onAction;

                  return (
                    <VirtualExpressTicketButton
                      event={eventState.events[c.getAttribute("data-event")]}
                      inline={true}
                      consumePlayAction={c.hasAttribute(
                        "data-consume-play-action"
                      )}
                      onAction={onAction}
                      appSettings={widgetProps.appSettings}
                    />
                  );
                })()
              ) : (
                <TicketButton
                  event={eventState.events[c.getAttribute("data-event")]}
                  inline={true}
                  showWishlist={c.hasAttribute("data-show-wishlist")}
                  onlyWishlist={c.hasAttribute("data-only-wishlist")}
                  appSettings={widgetProps.appSettings}
                />
              )
            ) : c.getAttribute("data-pass-bucket") ? (
              (() => {
                const details =
                  PassStore.getPassTypeByCode(
                    c.getAttribute("data-pass-bucket")
                  ) || {};
                const quantity = c.getAttribute("data-quantity");
                const discount = c.getAttribute("data-discount");

                return (
                  <PassButton
                    disabled={false}
                    label={c.getAttribute("data-buy-label")}
                    code={details.code}
                    price={details.price}
                    details={details}
                    target={{
                      pathname: `/passes/buy/${details.code}`,
                      query: Object.assign(
                        {},
                        quantity && { quantity: quantity },
                        discount && { discount_code: discount }
                      ),
                      state: { fromMainListing: true }
                    }}
                  />
                );
              })()
            ) : c.getAttribute("data-pass") ? (
              <ScanPassButton
                passId={c.getAttribute("data-pass")}
                label={c.getAttribute("data-label")}
              />
            ) : c.getAttribute("data-vote") ? (
              <VoteButton
                label={c.getAttribute("data-label")}
                eventId={c.getAttribute("data-vote-event")}
              />
            ) : c.getAttribute("data-add-to-cart") ? (
              <AddToCartButton
                label={c.getAttribute("data-label")}
                eventId={eventState.events[c.getAttribute("data-event-id")]}
                passBucketId={c.getAttribute("data-pass-bucket-id")}
              />
            ) : c.getAttribute("data-view-cart") ? (
              <ViewCartButton
                label={c.getAttribute("data-label")}
                showCart={showCart}
              />
            ) : c.getAttribute("data-reset-cart") ? (
              <ResetCartButton
                label={c.getAttribute("data-label")}
                resetCart={resetCart}
              />
            ) : !c.getAttribute("data-payment")
              ? null
              : PersonStore.isLoggedIn()
              ? (
                  (() => {

                    const onAction = e => {
                      editPaymentMethodActionHandlers.forEach(fn => {
                        fn(e);
                      });
                    };

                    // Allow payment update to trigger an action.
                    window.__EVENTIVE_EVERYWHERE_EDIT_PAYMENT_METHOD_ON_ACTION = onAction;

                    return (
                      <EditPaymentMethodButton
                        label={c.getAttribute("data-label")}
                      />
                    );
                  })()
                )
              : null
            }
          </WidgetContainer>,
          c
        );
      });

      // Inject button/link containers
      [
        [customButtonContainers, customButtonContents, {}],
        // If hijacked, allow hijacker to handle custom link clicks instead
        !window.EVENTIVE_EVERYWHERE_HIJACK && [
          customLinkContainers,
          customLinkContents,
          { noClass: true }
        ]
      ]
        .filter(p => !!p)
        .forEach(([containers, contents, { noClass }]) => {
          Array.from(containers).forEach((c, i) => {
            ReactDOM.render(
              <WidgetContainer noClass={noClass} {...widgetProps}>
                <CustomButton
                  eventId={c.getAttribute("data-event")}
                  innerHTML={contents[i]}
                />
              </WidgetContainer>,
              c
            );
          });
        });

      // Inject login/logout
      Array.from(document.querySelectorAll(".eventive-login")).forEach(c => {
        ReactDOM.render(
          <WidgetContainer noClass={true} {...widgetProps}>
            <LoginWidget
              loginButtonText={c.getAttribute("data-login-label")}
              logoutButtonText={c.getAttribute("data-logout-label")}
            />
          </WidgetContainer>,
          c
        );
      });

      // Inject hijacker
      if (window.EVENTIVE_EVERYWHERE_HIJACK) {
        let hijackContainer = document.getElementById(
          "eventiveHijackContainer"
        );
        if (!hijackContainer) {
          hijackContainer = document.createElement("div");
          hijackContainer.setAttribute("id", "eventiveHijackContainer");
          document.body.appendChild(hijackContainer);
        }

        ReactDOM.render(
          <WidgetContainer
            noClass={true}
            {...widgetProps}
            ref={r => {
              hijackContainerRef = r;
            }}
          >
            <div />
          </WidgetContainer>,
          hijackContainer
        );
      }
    }
  }

  function getCurrentCartOrder() {
    return OrderStore.getCartOrder();
  }

  function updateCart(subitem) {
    const cartOrder = OrderStore.getCartOrder();
    let updatedSubitems = cartOrder.subitems;
    updatedSubitems.push(subitem);
    OrderActions.updateCart({ subitems: updatedSubitems });
  }

  function showCart() {
    const orderOptions = OrderStore.getCartOrder();
    initiateCheckout({
      order: orderOptions
    });
  }

  function resetCart() {
    OrderActions.resetCart.defer();
  }

  function initiateCheckout(options) {
    console.log("initiateCheckout options");
    console.log(options);
    // Wait for app settings to be loaded before initiating.
    if (!widgetProps.appSettings) {
      _update();
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          initiateCheckout(options).then(resolve).catch(reject);
        }, 100);
      });
    }

    // Injects a checkout modal to the page
    let targetEl = document.getElementById("eventiveCheckoutContainer");
    if (!targetEl) {
      targetEl = document.createElement("div");
      targetEl.setAttribute("id", "eventiveCheckoutContainer");
      document.body.appendChild(targetEl);
    }

    let checkoutResolve_, checkoutReject_;
    const checkoutPromise = new Promise((resolve, reject) => {
      checkoutResolve_ = resolve;
      checkoutReject_ = reject;
    });

    // Listen for errors from within the app that aren't caught
    const onUnhandledRejectionEvent = event => {
      event.preventDefault();
      _destroy();
      checkoutReject_(event.reason);
    };
    window.addEventListener("unhandledrejection", onUnhandledRejectionEvent);

    const _destroy = () => {
      ReactDOM.unmountComponentAtNode(targetEl);
      window.removeEventListener(
        "unhandledrejection",
        onUnhandledRejectionEvent
      );
      targetEl.remove();
    };
    let checkoutResolve = data => {
      _destroy();
      checkoutResolve_(data);
    };
    let checkoutReject = data => {
      _destroy();
      checkoutReject_(data);
    };

    if (
      !options ||
      !options.order ||
      !options.order.subitems ||
      !options.order.subitems.length
    ) {
      checkoutReject(
        new Error(
          "Invalid Eventive#initiateCheckout request: no subitems provided"
        )
      );
      return checkoutPromise;
    }

    try {
      ReactDOM.render(
        <WidgetContainer noClass={true} {...widgetProps}>
          <CheckoutWidget
            options={options}
            onSuccess={checkoutResolve}
            onCancel={checkoutResolve}
            onError={checkoutReject}
          />
        </WidgetContainer>,
        targetEl
      );
    } catch (e) {
      console.log("** Unexpected Eventive error **");
      console.trace(e);
      checkoutReject(new Error(`An unexpected system error occurred.`));
    }

    return checkoutPromise;
  }

  function loginWithToken(opts) {
    const loginPromise = new Promise((resolve, reject) => {
      if (!opts || !opts.eventiveToken) {
        reject(
          new Error(
            "Invalid Eventive#loginWithToken request: no eventiveToken provided"
          )
        );
        return;
      }

      PersonActions.refreshWithToken({
        token: opts.eventiveToken,
        callback: (err, data) => {
          if (err) {
            reject(err);
          } else {
            PassActions.fetchAll({});
            resolve(data);
          }
        }
      });
    });

    return loginPromise;
  }

  function loginSundance(opts) {
    const loginPromise = new Promise((resolve, reject) => {
      if (!opts || !opts.userToken) {
        reject(
          new Error(
            "Invalid Eventive#loginSundance request: no userToken provided"
          )
        );
        return;
      }

      PersonActions.loginWithSundance({
        externalToken: opts.userToken,
        callback: (err, data) => {
          if (err) {
            reject(err);
          } else {
            PassActions.fetchAll({});
            resolve(data);
          }
        }
      });
    });

    return loginPromise;
  }

  function logout() {
    return new Promise((resolve, reject) => {
      PersonActions.logout.defer();
      setTimeout(() => resolve(), 100);
    });
  }

  function openVote(eventId, tickets) {
    const targetEl = document.createElement("div");
    document.body.appendChild(targetEl);

    ReactDOM.render(
      <WidgetContainer noClass={true} {...widgetProps}>
        <BallotingRecord
          eventId={eventId}
          tickets={tickets}
          onClose={() => {}}
        />
      </WidgetContainer>,
      targetEl
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/loader.js